// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".deceased-page-box .van-popup {\n  border-radius: 0.4rem;\n}\n", ""]);
// Exports
module.exports = exports;
